import { render, staticRenderFns } from "./Manual.vue?vue&type=template&id=147fc816&scoped=true&"
import script from "./Manual.vue?vue&type=script&lang=js&"
export * from "./Manual.vue?vue&type=script&lang=js&"
import style0 from "./Manual.vue?vue&type=style&index=0&id=147fc816&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147fc816",
  null
  
)

export default component.exports